import "../../../../../Haendlerverwaltung/plugins/wkfg3_haendlerverwaltung/js/scss/user-style.scss";

import "oc-commons/extensions/StringExtensions.js";
import "oc-commons/extensions/jquery.oc.extensions.js";
import 'handlebars';
import "oc-commons/extensions/HandlebarsExtensions.js";
import "oc-ui/dialogs/DialogsJquery.js";
import I18N from 'oc-I18N';
import "oc-ui/errorHandling.js";
import Wkfg2BackendApi from "oc-app/Wkfg2BackendApi.js";
import Commons from "oc-commons/Commons";
import { configurationOfUser, configurationOfHersteller, configurationOfVerkaeufer } from "./user/configurationListOfUser.js";
import { configurationTiles } from "../../../../../Haendlerverwaltung/plugins/wkfg3_haendlerverwaltung/js/user/configurationTiles";
import Stammdaten from "../../../../../Haendlerverwaltung/plugins/wkfg3_haendlerverwaltung/js/user/Stammdaten";
import Haendlerverwaltung from "../../../../../Haendlerverwaltung/plugins/wkfg3_haendlerverwaltung/js/user/Haendlerverwaltung";

window.APP = {
    settings: SETTINGS,
    wkfgBackendApi: new Wkfg2BackendApi(SETTINGS.wkfgBackendUrl)
};

$.ajaxSetup({
    headers: {
        'X-CSRF-Token': APP.settings.xcsrfToken
    }
});

if (APP.settings?.i18n_json) {
    I18N.setKeyValueMap(APP.settings.i18n_json);
}

$(function () {
    if ($('.shortcode-config').length > 0) {
        const subconfig = JSON.parse($('.shortcode-config').html());
        Commons.mergeSafe(APP.settings, subconfig);
        if (subconfig.userLoggedIn) {
            console.log(subconfig)
            if ($('.configuration-list-of-user-container').length > 0) {
                $('.configuration-list-of-user-container').each(function () {
                    const element = $(this);
                    const filterConfig = subconfig;
                    configurationOfUser(element, filterConfig);
                });
            } else {
                $('.configuration-list-of-verkaeufer-container').each(function () {
                    const element = $(this);
                    const filterConfig = subconfig;
                    configurationOfVerkaeufer(element, filterConfig);
                });
                $('.configuration-list-of-hersteller-container').each(function () {
                    const element = $(this);
                    const filterConfig = subconfig;
                    configurationOfHersteller(element, filterConfig);
                });
            }


            if (subconfig.stammdaten) {
                new Stammdaten($('#singleHaendlerContainer'), subconfig.haendler);

            }
            if (subconfig.haendlerverwaltung) {
                new Haendlerverwaltung(subconfig.haendler);
            }

        }
        else {
            $('.configurations-tiles-container').each(function () {
                var element = $(this);
                configurationTiles(element, subconfig);
            });
        }
    }
});

